<i18n>
{
  "fr":{
    "Label": "Exporter"
  }
}
</i18n>

<template>
  <button
    :type="type"
    class="btn btn-success"
    @click="$emit('click')">
    <IconExcel />
    <span class="d-inline-block ml-2">{{ computedLabel }}</span>
  </button>
</template>

<script>
import { computed, props } from '.';

export default {
  props,
  computed,
};
</script>
